import type { PanelType } from '@src/types/LayoutConfig';

export const MARKET_TAB_PANEL_TYPES = [
  'marketCards',
  'watchlist',
  'predictionMarkets',
] as const satisfies readonly PanelType[];
export type MarketTabPanelType = (typeof MARKET_TAB_PANEL_TYPES)[number];

export function isEnabledMarketTabPanelType(
  panelType: PanelType | string | undefined,
  enablePredictionMarkets: boolean
): panelType is MarketTabPanelType {
  return (
    MARKET_TAB_PANEL_TYPES.includes(panelType as MarketTabPanelType) &&
    (enablePredictionMarkets || panelType !== 'predictionMarkets')
  );
}
